import React, { useEffect, useState, useCallback } from 'react';
import { systemApi } from '../../services/api';
import { useWebSocket } from '../../hooks/useWebSocket';
import './System.css';

export default function System() {
  const [m, setM] = useState<any>(null);
  useEffect(() => { systemApi.status().then(({ data }) => setM(data)).catch(() => {}); }, []);
  const handleWs = useCallback((msg: any) => { if (msg.type === 'system_update') setM(msg.payload); }, []);
  useWebSocket(handleWs);
  const cls = (v: number, w: number, b: number) => v >= b ? 'bad' : v >= w ? 'warn' : 'ok';
  if (!m) return <div className="sy-loading">Məlumat gözlənilir...</div>;
  return (
    <div className="sy-page">
      <div className="sy-grid">
        {[
          { label:'CPU TEMP', val:`${m.cpu_temp}°C`, c:cls(m.cpu_temp,55,70), bar:m.cpu_temp, max:100 },
          { label:'CPU YÜK', val:`${m.cpu_load}%`, c:cls(m.cpu_load,65,85), bar:m.cpu_load, max:100 },
          { label:'RAM', val:`${m.ram_percent}%`, c:cls(m.ram_percent,70,90), bar:m.ram_percent, max:100 },
          { label:'SD KART', val:`${m.disk_percent}%`, c:cls(m.disk_percent,70,90), bar:m.disk_percent, max:100 },
        ].map(s => (
          <div key={s.label} className="sy-card">
            <div className="sy-card-title">{s.label}</div>
            <div className={`sy-val ${s.c}`}>{s.val}</div>
            <div className="sy-bar"><div className={`sy-bar-fill ${s.c}`} style={{width:`${s.bar}%`}}/></div>
          </div>
        ))}
      </div>
      <div className="sy-card sy-bat">
        <div className="sy-card-title">BATAREYA</div>
        <div className={`sy-val ${cls(100-m.battery_percent,60,80)}`}>{m.battery_charging?'⚡':'🔋'} {m.battery_percent}%</div>
        <div className="sy-bar"><div className="sy-bar-fill ok" style={{width:`${m.battery_percent}%`}}/></div>
        <div className="sy-sub">{m.battery_charging?'Şarj olunur':'Batareya ilə işləyir'}</div>
      </div>
      <div className="sy-sec-title">SERVİSLƏR</div>
      <div className="sy-services">
        {['motion','nginx','fail2ban','cam-tunnel','mqtt-publisher','hls-stream','ups-monitor'].map(s => (
          <div key={s} className="sy-svc"><div className="sy-dot"/><span>{s}</span><span className="sy-active">AKTİV</span></div>
        ))}
      </div>
      <div className="sy-sec-title">4G BAĞLANTI</div>
      <div className="sy-info">
        <div className="sy-row"><span>Operator</span><span>Azercell</span></div>
        <div className="sy-row"><span>Siqnal</span><span className="ok">{m.signal_strength}%</span></div>
        <div className="sy-row"><span>Tunnel</span><span className="ok">AKTİV</span></div>
      </div>
      <div className="sy-updated">Son yenilənmə: {new Date(m.timestamp*1000).toLocaleTimeString('az-AZ')}</div>
    </div>
  );
}
